import { QuestionItem } from '@/entities/questions-page/QuestionItem/ui/QuestionItem.jsx'
import './ui/QuestionItem.scss'
export default QuestionItem
